module.exports = __webpack_public_path__ + "static/media/offers-restaurant.53b475e8.svg";